import React from 'react'
import dashboardicon from '../../../icons/chart-bar.svg'
import repeat from '../../../icons/repeat.svg'

function Sidebar() {
    return (
        <div className='sidebar' >


            <div className='icon-container-sidebar' >

                <button className="nostylebutton">
                    <img src={dashboardicon} alt="Chart Bar Icon" />
                </button>

                <button className="nostylebutton">
                    <img src={repeat} alt="Chart Bar Icon" />
                </button>

                <button className="nostylebutton">
                    <img src={dashboardicon} alt="Chart Bar Icon" />
                </button>

                <button className="nostylebutton">
                    <img src={dashboardicon} alt="Chart Bar Icon" />
                </button>

            </div>



        </div>
    )
}

export default Sidebar